<div
    class="sidenav no-padding is-relative"
    [@toggleFilters]="showSidenav ? 'open' : 'closed'"
>
    <div
        class="is-clipped"
        [@toggleFilters]="showSidenav ? 'contentOn' : 'contentOff'"
    >
        <ng-content></ng-content>
    </div>
    <a
        class="button ra-primary-green is-small toggle-button has-text-white"
        (click)="toggleSideNav()"
    >
        <i
            *ngIf="showSidenav"
            class="fas fa-angle-left"
        ></i>
        <i
            *ngIf="!showSidenav"
            class="fas fa-angle-right"
        ></i>
    </a>
</div>
